import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getHomeProductSlice = createSlice({
  name: "getHomeProduct",
  initialState,
  reducers: {
    getHomeProductStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getHomeProductSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getHomeProductFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getHomeProductStart,
  getHomeProductSuccess,
  getHomeProductFailure,
  clearError,
  clearMessage,
} = getHomeProductSlice.actions;

export default getHomeProductSlice.reducer;
